const NullComponent = (): null => null;
export default NullComponent;
